<template>
  <div>
    <b-card no-body>
      <div class="m-2">
        <!-- Add User Name -->
        <div v-if="showPageName">
          <b-row>
            <b-col cols="12" md="12">
              <h2>Add Page Permissions</h2>
              <br />
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12" md="12">
              <h4>Page Name</h4>
            </b-col>
            <b-col md="4">
              <b-form-group>
                <b-form-input v-model="addForm.name" placeholder="Page Name" />
              </b-form-group>
            </b-col>
          </b-row>

          <!-- Add Button -->
          <b-row>
            <b-col cols="12" md="12">
              <br />
            </b-col>
            <b-col cols="12" md="12" class="
                      d-flex
                      align-items-center
                      justify-content-start
                      mb-1 mb-md-0
                    ">
              <b-button variant="primary" @click="addNewItem()">
                Add New
              </b-button>
            </b-col>
          </b-row>
        </div>

        <div v-if="showPermissions">
          <b-row>
            <b-col cols="12" md="12">
              <h2>Choose Permissions</h2>
              <br />
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12" md="12">
              <br />
            </b-col>
            <b-col cols="12">
              <b-form-group label="Assign Permission to The User" v-slot="{ ariaDescribedby }" class="modify_checkbox">
                <b-form-checkbox-group>
                  <b-form-checkbox v-for="option in PermissionList" v-model="permissionForm.permission_ids"
                    :key="option.value" :value="option.value" :aria-describedby="ariaDescribedby" name="flavour-3a">
                    {{ option.text }}
                  </b-form-checkbox>
                </b-form-checkbox-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12" md="12">
              <br />
            </b-col>
            <b-col cols="12" md="12" class="
                      d-flex
                      align-items-center
                      justify-content-start
                      mb-1 mb-md-0
                    ">
              <b-button variant="primary" @click="addPermission()">
                Finish Creating Page Permissions
              </b-button>
            </b-col>
          </b-row>
        </div>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BLink,
  BDropdown,
  BDropdownItem,
  BTooltip,
  BFormGroup,
  BFormSelect,
  BSpinner,
  BModal,
  VBModal,
  BCardText,
  BFormCheckboxGroup,
  BFormCheckbox,
} from "bootstrap-vue";
import vSelect from "vue-select";
import { onUnmounted } from "@vue/composition-api";
import store from "@/store";
import router from "@/router";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BLink,
    BDropdown,
    BDropdownItem,
    BTooltip,
    vSelect,
    BFormGroup,
    BFormSelect,
    BSpinner,
    BModal,
    BCardText,
    BFormCheckbox,
    BFormCheckboxGroup,
  },
  data() {
    return {
      addForm: {
        name: "",
      },
      selected: "",
      option: [],
      take: 75,
      params: {
        form: {},
        path: "",
      },
      params2: {
        form: {},
        path: "",
      },
      roleForm: {
        roleIds: [],
      },
      permissionForm: {
        page_id: '',
        permission_ids: [],
      },
      user_id: "",
      RoleList: [],
      roleSelected: "",
      PermissionList: [],
      departmentList: [],
      jobTitleList: [],
      showPageName: true,
      showPermissions: false,
    };
  },
  mounted() {
    this.getPermissions();
  },
  methods: {
    async getPermissions() {
      await this.getList(`/permission?take=1000`);
      this.all_data.data.forEach((item) => {
        this.PermissionList.push({
          value: item.id,
          text: item.name,
        });
      });
    },
    addNewItem() {
      (this.params.form = this.addForm),
        (this.params.path = "/page"),
        this.$store
          .dispatch("create", this.params)
          .then((res) => {
            this.permissionForm.page_id = res.data.data.id
            this.showPageName = false;
            this.showPermissions = true;
            this.$toast({
              component: ToastificationContent,
              position: "top-right",
              props: {
                title: "User Created",
                icon: "success",
                variant: "InfoIcon",
                text: "Page " + this.addForm.name + " Created Successfully Please Choose Its Permission",
              },
            });
          })
          .catch((error) => {
            if (error.response.status === 400) {
              for (let item in error.response.data) {
                this.$toast({
                  component: ToastificationContent,
                  position: "top-right",
                  props: {
                    title: "validation error",
                    variant: "danger",
                    text: error.response.data[item][0],
                  },
                });
              }
            }
          });
    },
    addPermission() {
      (this.params.form = this.permissionForm),
        (this.params.path = `/page-permission`),
        this.$store
          .dispatch("create", this.params)
          .then(() => {
            this.$router.push({ name: 'users' })
            this.$toast({
              component: ToastificationContent,
              position: "top-right",
              props: {
                title: "Page Permissions Completed",
                icon: "success",
                variant: "InfoIcon",
                text: "Page Permissions " + this.addForm.name + " Completed Successfully",
              },
            });
          })
          .catch((error) => {
            if (error.response.status === 400) {
              for (let item in error.response.data) {
                this.$toast({
                  component: ToastificationContent,
                  position: "top-right",
                  props: {
                    title: "validation error",
                    variant: "danger",
                    text: error.response.data[item][0],
                  },
                });
              }
            }
          });
    },
  },
};
</script>
<style scoped>
.modify_checkbox {
  display: flex;
  flex-flow: row wrap;
  justify-content: flex-start;
  align-items: center;
  row-gap: 30px;
  column-gap: 5px;
}

.custom-checkbox {
  width: 18rem;
  height: 3rem;
}
</style>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>